import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SERVICES, HEADWAY } from "../data/site";

export default function Services() {
    return (
        <div data-testid="services-page" className="pb-28">
            <PageHeader
                testid="services-header"
                breadcrumb="Services & Specialties"
                title="Care for every age"
                number="03"
                label="Services & Specialties"
                heading="Care for every age, at every pace"
            >
                <p className="mt-6 text-sm leading-relaxed text-amber-100/70 sm:text-base">
                    At NeuroPlay Counseling, LLC in Longwood, Florida, we provide
                    play therapy, EMDR and trauma-informed therapy for children, teens and adults — plus
                    neuropsychology-based support for regulation, anxiety, and crisis intervention. Every
                    service is rooted in a safe, healing space led by brilliant, credentialed therapists.
                </p>
                <div className="mt-10 overflow-hidden rounded-3xl ring-1 ring-amber-500/15">
                    <div className="relative">
                        <img
                            src="https://images.pexels.com/photos/8654102/pexels-photo-8654102.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                            alt="A child at play in a warm therapy room"
                            className="h-64 w-full object-cover sm:h-80"
                        />
                        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/70 to-transparent p-8">
                            <p className="max-w-xl font-serif text-xl italic text-amber-50 sm:text-2xl">
                                "Children say with toys what they cannot yet say
                                with words."
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => (
                        <motion.div
                            key={s.title}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.06 }}
                            className="rounded-2xl border border-amber-500/15 bg-[#1F1510]/50 p-7 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-amber-400/50"
                        >
                            <span className="text-xs uppercase tracking-[0.2em] text-amber-400/80">
                                {s.age}
                            </span>
                            <h3 className="mt-3 font-serif text-xl text-amber-100">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-amber-100/60">
                                {s.body}
                            </p>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-14 rounded-3xl border border-amber-500/20 bg-[#281D17] p-10 text-center">
                    <p className="font-serif text-xl text-amber-100 sm:text-2xl">
                        Not sure which door is yours? That's what the first
                        conversation is for.
                    </p>
                    <a
                        href={HEADWAY}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-6 inline-flex items-center gap-2 rounded-full bg-amber-500 px-7 py-3.5 text-sm font-semibold text-[#1F1510] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-amber-400"
                    >
                        <Sparkles className="h-4 w-4" />
                        Start with a free benefits check
                    </a>
                </div>
            </PageHeader>
        </div>
    );
}
